<template>
  <div class="bg-white shadow-md border p-2">
    <div class="flex flex-col items-center">
      <div class="flex justify-center border-b w-full mb-2">
        <p class="text-sm">
          {{ agents.find((agent) => agent.uname == call.agent)?.fullname.slice(0, 20) }}
          <v-icon
            :class="call?.call_type == 1 ? 'text-green-500' : 'text-orange'"
            size="20"
            >{{
              call?.call_type == 1
                ? "mdi-arrow-right-thick"
                : "mdi-arrow-left-thick"
            }}</v-icon
          >
          {{ call?.mdn }}
        </p>
      </div>
      <div class="flex gap-2 items-center justify-between w-full">
        <div class="flex items-center gap-2 text-xs">
          <p class="bg-primary-500 text-white px-2 py-1 rounded-md">
            {{
              Math.floor(call?.duration / 60)
                .toString()
                .padStart(2, "0")
            }}:{{ (call?.duration % 60).toString().padStart(2, "0") }}
          </p>
          <p>
            {{ call?.skill }}
          </p>
        </div>
        <div class="flex gap-1">
          <v-icon
            class="rounded-lg p-4 !border shadow-md !text-sm transition-all duration-300"
            :class="monitorActive ? 'opacity-50 cursor-not-allowed pointer-events-none' : 'cursor-pointer hover:!bg-primary-500 hover:text-white'"
            @click="callListening(call?.channel)"
            >mdi-headphones</v-icon
          >
          <v-icon
            class="rounded-lg p-4 !border shadow-md !text-sm transition-all duration-300"
            :class="monitorActive ? 'opacity-50 cursor-not-allowed pointer-events-none' : 'cursor-pointer hover:!bg-primary-500 hover:text-white'"
            @click="callWhisper(agents.find((agent) => agent.uname == call.agent)?.channel, call.agent)"
            >mdi-microphone</v-icon
          >
          <!-- <v-icon
            class="rounded-lg p-4 cursor-pointer hover:!bg-red-500 hover:text-white transition-all duration-300 !border shadow-md !text-sm"
            @click="hangupCall(call?.channel)"
            >mdi-phone-hangup</v-icon
          > -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    activeCall: {
      required: true,
    },
    agentsList: {
      required: true,
    },
  },
  data() {
    return {
      call: null,
      agents: [],
    };
  },
  methods: {
    async callListening(channel) {
      if (this.monitorActive) return;
      try {
        var resp = await this.MonitorAction({
          action: 1,
          channel,
          workstatus: 1,
        });

        if (!resp.success) {
          this.SetMessageDialog({ show: true, message: resp.message });
        }
      } catch (err) {
        let message = err.message;
        if (err.response) {
          message = err.response.data.message;
        }
        this.SetMessageDialog({ show: true, message: message });
      }
    },
    async callWhisper(channel, agent) {
      if (this.monitorActive) return;
      try {
        var resp = await this.MonitorAction({
          action: 2,
          channel,
          agent,
          workstatus: 1,
        });
        if (!resp.success) {
          this.SetMessageDialog({ show: true, message: resp.message });
        }
      } catch (err) {
        let message = err.message;
        if (err.response) {
          message = err.response.data.message;
        }
        this.SetMessageDialog({ show: true, message: message });
      }
    },
    async hangupCall(channel) {
      try {
        var resp = await this.MonitorAction({
          action: 4,
          channel,
          workstatus: 1,
        });
        if (!resp.success) {
          this.SetMessageDialog({ show: true, message: resp.message });
        }
      } catch (err) {
        let message = err.message;
        if (err.response) {
          message = err.response.data.message;
        }
        this.SetMessageDialog({ show: true, message: message });
      }
    },
    ...mapActions(["MonitorAction", "SetMessageDialog"]),
  },
  watch: {
    activeCall(newValue) {
      this.call = newValue;
    },
    agentsList(newValue) {
      this.agents = newValue;
    },
  },
  mounted() {
    this.call = this.activeCall;
    this.agents = this.agentsList;
  },
  computed: {
    ...mapGetters(["inCall"]),
    currentLocale() {
      return this.$vuetify.locale.current;
    },
    // Disable listen/whisper while admin is already in a monitor session.
    monitorActive() {
      return this.inCall;
    },
  },
};
</script>

<style></style>
